export * from './document-add/document-add.component';
export * from './document-delete/document-delete.component';
export * from './document-select/document-select.component';
export * from './document-update/document-update.component';